module.exports = {
  caseLabels: [{label: 'AMCP', value: 'AMCP'}],
  caseSearchStatusesDefault: [],
  showCaseDetailsInList: ['name', 'sex'],
  searchCaseDetailsInModal: ['name'],
  components: require('./components'),
  messages: require('./messages'),
  releaseNotes: require('./releaseNotes')
}
